import { ElementType, ReactNode } from 'react';
import { View } from 'react-native';
import { Button } from '../../Core/Button/Button';
import { Typography } from '../../Core/Typography/Typography';
import { IconProps } from '../../Icons/Icons.types';
import { cn } from '../../lib/utils';

interface AssetCardItem {
  label: string | ReactNode;
  value: string | ReactNode;
}

interface AssetCardDynamicProps {
  showAssetDetails: boolean;
  className?: string;
  onButtonPress?: () => void;
  buttonText?: string;
  showButton: boolean;
  assetName?: string;
  assetSubtitle?: string;
  iconComponent: ElementType;
  iconProps: IconProps;
  items: AssetCardItem[];
}

export const AssetCard = ({
  showAssetDetails = true,
  className,
  onButtonPress,
  buttonText,
  showButton = true,
  assetName,
  assetSubtitle,
  iconComponent: IconComponent,
  iconProps,
  items,
}: AssetCardDynamicProps) => {
  return (
    <View
      className={cn('bg-neutral-600 px-3 py-4 w-full rounded-2xl', className)}>
      {showAssetDetails && (
        <View className="flex-row mb-1 justify-between">
          <View className="flex-row items-center">
            <IconComponent {...iconProps} />
            <Typography className="ml-2">{assetName}</Typography>
          </View>
          {showButton && (
            <Button
              size="small"
              fullWidth={false}
              className="bg-neutral-500 px-3 justify-center h-7 ml-3"
              onPress={onButtonPress}>
              <Typography size="small" className="h-5">
                {buttonText}
              </Typography>
            </Button>
          )}
        </View>
      )}
      {assetSubtitle && (
        <View className="flex-row my-1 justify-between">
          <View className="flex-row items-center">
            <Typography size="small" className="text-neutral-300">
              {assetSubtitle}
            </Typography>
          </View>
        </View>
      )}

      {items.map((item, index) => (
        <View className="flex-row my-1 justify-between" key={index}>
          {typeof item.label === 'string' ? (
            <Typography size="small" className="text-neutral-300">
              {item.label}
            </Typography>
          ) : (
            <>{item.label}</>
          )}
          {typeof item.value === 'string' ? (
            <Typography size="small">{item.value}</Typography>
          ) : (
            <>{item.value}</>
          )}
        </View>
      ))}
    </View>
  );
};
